var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.page.name)+" "),(_vm.page.is_main_page)?_c('v-icon',{staticClass:"mb-1 ml-2",attrs:{"color":"black"}},[_vm._v("mdi-home")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }